// extracted by mini-css-extract-plugin
export default {"connection":"TSsV","connected":"rLQr","notConnected":"kPjS","fieldDescription":"rSh3"};